import React from "react";
import { Alert, Avatar, Select } from "@opendate-app/setlist";

import { useLandingPage } from "../LandingPageBuilderContainer";

const styles = {
  stack: { display: "flex", flexDirection: "column", gap: 16, marginTop: 24, maxWidth: 640 },
};

const initialsFor = (name) => name.split(/\s+/).filter(Boolean).slice(0, 2).map((word) => word[0].toUpperCase()).join("");

const VenueStep = ({ setStep }) => {
  const { page, props, savePage } = useLandingPage();

  const options = props.venueOwnerships.map((venue) => ({
    value: venue.id,
    label: venue.name,
    avatar: <Avatar size="xs" src={venue.logoUrl || undefined} initials={initialsFor(venue.name)} alt="" />,
  }));

  const choose = async (venueOwnershipId) => {
    if (!venueOwnershipId) return;
    const saved = venueOwnershipId === page.venue_ownership_id || await savePage({ venue_ownership_id: venueOwnershipId });
    if (saved) setStep("template");
  };

  return (
    <div style={styles.stack}>
      {page.template_key && (
        <Alert color="warning" title="Switching venues resets your blueprint, content and signup settings." />
      )}

      <Select
        label="Venue"
        placeholder="Select a venue"
        searchable
        options={options}
        value={page.venue_ownership_id}
        onChange={choose}
      />
    </div>
  );
};

export default VenueStep;
